'use client';

import dynamic from 'next/dynamic';
import type { TurnstileProps } from 'react-turnstile';

const Turnstile = dynamic(() => import('react-turnstile').then((mod) => mod.default), {
  ssr: false,
  loading: () => null,
});

export type { BoundTurnstileObject } from 'react-turnstile';

export function DeferredTurnstile(props: TurnstileProps) {
  return <Turnstile {...props} />;
}
